"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchInvoiceIssuancePendingDto = void 0;
const class_validator_1 = require("class-validator");
const cursor_pagination_1 = require("../cursor-pagination");
const PENDING_STATUSES = [
    "pending_authorization",
    "pending_tax_data",
    "technical_error",
    "retrying",
    "issued",
    "failed",
];
class SearchInvoiceIssuancePendingDto extends cursor_pagination_1.CursorPaginationOptions {
    status;
    issuerUserId;
}
exports.SearchInvoiceIssuancePendingDto = SearchInvoiceIssuancePendingDto;
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsIn)(PENDING_STATUSES),
    __metadata("design:type", String)
], SearchInvoiceIssuancePendingDto.prototype, "status", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], SearchInvoiceIssuancePendingDto.prototype, "issuerUserId", void 0);
